// extracted by mini-css-extract-plugin
export var container = "EmbeddedOtherTextField-module__container___Qbr5g";
export var formContainer = "EmbeddedOtherTextField-module__formContainer___742O0";
export var formWrapper = "EmbeddedOtherTextField-module__formWrapper___BWseP";
export var gameTitle = "EmbeddedOtherTextField-module__gameTitle___rzlJw";
export var internalContainer = "EmbeddedOtherTextField-module__internalContainer___pRqT9";
export var largeTextBox = "EmbeddedOtherTextField-module__largeTextBox___IQe5e";
export var otherInputContainer = "EmbeddedOtherTextField-module__otherInputContainer___sFu1w";
export var pageContainer = "EmbeddedOtherTextField-module__pageContainer___4twPG";
export var pageNavButton = "EmbeddedOtherTextField-module__pageNavButton___P+u5C";
export var primaryButton = "EmbeddedOtherTextField-module__primaryButton___MB9oK";
export var requiredStar = "EmbeddedOtherTextField-module__requiredStar___EXkB2";
export var rowContainer = "EmbeddedOtherTextField-module__rowContainer___6rvyH";
export var secondaryButton = "EmbeddedOtherTextField-module__secondaryButton___+b6Ud";
export var slimContainer = "EmbeddedOtherTextField-module__slimContainer___c+xO+";
export var spinnerContainer = "EmbeddedOtherTextField-module__spinnerContainer___FPx1W";
export var textField = "EmbeddedOtherTextField-module__textField___Vh8WS";
export var textFieldLabel = "EmbeddedOtherTextField-module__textFieldLabel___bOh+U";
export var textFieldMultiline = "EmbeddedOtherTextField-module__textFieldMultiline___Uxltq";
export var textFieldMultilineWrapper = "EmbeddedOtherTextField-module__textFieldMultilineWrapper___uky84";
export var textFieldText = "EmbeddedOtherTextField-module__textFieldText___xPqah";
export var titleStatusContainer = "EmbeddedOtherTextField-module__titleStatusContainer___eH1lT";